import React, { useState, useRef, useContext } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ContextMenu } from 'primereact/contextmenu'
import { IconButton, Tooltip } from '@mui/material'
import { FilterAlt, FilterAltOff } from '@mui/icons-material'
import { LoadingContext } from '../M_Utils'
import { M_Column } from '.'

export const M_SimpleTable = ({ header, columns, rows, selectedRows,
    onSelectionChange, limitHeight, width, color, secondColor, isSelectSingle,
    onMouseOver, isSelectMultiple, tableContextMenu, className, groupField,
    normal, large, rowGroupMode, headerTemplate, footerTemplate, isExpandedRows,
    reorder, filtersOnTable
}) => {
    const [contextSelection, setContextSelection] = useState(null)
    const [expandedRows, setExpandedRows] = useState(null)
    const [showColumnFilters, setShowColumnFilters] = useState(false)
    const ctx = useContext(LoadingContext)
    const dt = useRef(null)
    const cm = useRef(null)

    isSelectSingle = isSelectSingle ? isSelectSingle : false
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    secondColor = secondColor ? secondColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    const tableHeader = filtersOnTable
        ? (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
                <div>{header}</div>
                <Tooltip title={showColumnFilters ? 'Hide filters' : 'Show filters'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <span style={{ fontSize: '0.9rem', color }}>Filters</span>
                        <IconButton
                            size="small"
                            onClick={() => setShowColumnFilters(prev => !prev)}
                            style={{ color }}
                        >
                            {showColumnFilters ? <FilterAltOff fontSize="small" /> : <FilterAlt fontSize="small" />}
                        </IconButton>
                    </div>
                </Tooltip>
            </div>
        )
        : header

    return (
        <>
            <ContextMenu model={tableContextMenu ? tableContextMenu : null} ref={cm} onHide={() => { sessionStorage.removeItem('contextLine'); setContextSelection(null) }} />
            <DataTable
                tableStyle={{ width: width ? width : '100%', overflow: 'hidden' }}
                header={tableHeader}
                value={rows}
                size={normal && "normal" || large && "large" || "small"}
                selection={selectedRows}
                selectionMode={isSelectSingle ? 'radiobutton' : isSelectMultiple ? 'checkbox' : null}
                stripedRows
                responsiveLayout="scroll"
                scrollHeight={limitHeight}
                reorderableColumns={reorder}
                filterDisplay={showColumnFilters ? 'row' : undefined}
                ref={dt} //necessário para o export de CSV
                onSelectionChange={onSelectionChange}
                onContextMenu={tableContextMenu ? e => cm.current.show(e.originalEvent) : null}
                contextMenuSelection={tableContextMenu ? contextSelection : null}
                onContextMenuSelectionChange={(e) => {
                    setContextSelection(e.value)
                    try {
                        // Only store primitive values, avoid circular references from JSX elements
                        const safeValue = { id: e.value?.id }
                        sessionStorage.setItem('contextLine', JSON.stringify(safeValue))
                    } catch (err) {
                        console.warn('Could not serialize context line:', err)
                    }
                }}
                onMouseOver={onMouseOver}
                className={className ? className : 'defaultTable'}
                rowGroupMode={rowGroupMode && rowGroupMode || 'rowspan'}
                groupRowsBy={groupField ? groupField : null}
                sortField={groupField ? groupField : null}
                sortOrder={1}
                rowGroupHeaderTemplate={headerTemplate}
                rowGroupFooterTemplate={footerTemplate}
                expandableRowGroups={isExpandedRows}
                expandedRows={expandedRows}
                onRowToggle={(e) => setExpandedRows(e.data)}
            >
                {isSelectSingle ?
                    <Column
                        headerStyle={{
                            borderBottom: `2px solid ${color}`,
                            color: secondColor
                        }}
                        selectionMode="single"
                        className='TableSelectionColumn'
                        frozen
                    >
                    </Column>
                    : isSelectMultiple &&
                    <Column
                        headerStyle={{
                            borderBottom: `2px solid ${color}`,
                            color: secondColor
                        }}
                        selectionMode="multiple"
                        className='TableSelectionColumn'
                        frozen
                    >
                    </Column>
                }
                {columns?.map((col, index) => (
                    <M_Column
                        id={col?.id}
                        key={index}
                        field={col?.field}
                        header={col?.header}
                        dataType={col?.type}
                        body={col?.body}
                        headerStyle={{
                            borderBottom: `2px solid ${color}`,
                            color: secondColor,
                        }}
                        columnKey={col?.columnKey}
                        style={col?.style}
                        bodyStyle={col?.bodyStyle}
                        onDrop={col?.onDrop}
                        onDragEnter={col?.onDragEnter}
                        frozen={col?.frozen}
                        alignFrozen={col?.alignFrozen}
                        filter={filtersOnTable && !!col?.field}
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        filterPlaceholder={`Filter ${col?.header || col?.field || ''}`}
                    />
                ))}
            </DataTable >
        </>
    )
}

